/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-11-04 16:02:31                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-22 15:10:51                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Services
  * Styles
  * Components
  * WorkorderMap: Google map component
    * useEffect: load technicians informations
    * useEffect: Set marker on address
*/

/* Imports */
import GoogleMapReact from "google-map-react";
import { useEffect, useState } from "react";
/***/

/* Services */
import { api } from "../../../../services/api/api";
/***/

/* Styles */
import "./WorkorderMap.scss";
/***/

/* Components */
import MapMarker from "../../../../components/map-marker/MapMarker";
/***/

/**
* WorkorderMap: Google map component
* display workorder address and technicians position
* @param address - address object, target to be print with pin marker
*/
export function WorkorderMap({
  address,
  onTechClick,
  showUnavailable,
  unavailableTechs
}: {
  address?: EasyTech.Address,
  onTechClick: (tech: EasyTech.Technician) => void,
  showUnavailable?: boolean,
  unavailableTechs?: EasyTech.Technician[]
}) {
  const [center, setCenter] = useState<GoogleMapReact.Coords>({ lat: 48.0148731241412, lng: 5.570179638323609 });
  const [zoom, setZoom] = useState<number>(5);
  const [techPos, setTechPos] = useState<EasyTech.TechnicianPosition[]>();

  /**
  * useEffect: load technicians informations 
  */
  useEffect(() => {
    api.get("admin/technician_locations")
      .then((ret) => {
        if (Array.isArray(ret)) {
          setTechPos(ret as EasyTech.TechnicianPosition[]);
        } else {
          console.error("Invalid technician locations format:", ret);
          setTechPos([]);
        }
      })
      .catch((err) => console.error(err));
  }, []);
  /***/

  /**
  * useEffect: Set marker on address
  * @param address - reload on address change 
  */
  useEffect(() => {
    if (address && address.latitude && address.longitude) {
      setCenter({ lat: address.latitude, lng: address.longitude });
      setZoom(10);
    }
  }, [address]);
  /***/

  return (
    <div className="create-workorder-map ">
      <div className="map-wrapper">
        <GoogleMapReact center={center}
          zoom={zoom}
          options={{
            streetViewControl: false,
            mapTypeControl: false
          }}>

          {address && <MapMarker lat={address.latitude} lng={address.longitude} address={address} />}

          {Array.isArray(techPos) && techPos.length > 0 && techPos.filter((pos) => {
            if (showUnavailable === undefined || showUnavailable === true) return true;
            if (!unavailableTechs) return true;
            if (!pos.technician) return false;
            return !unavailableTechs.some((u) => u.id === pos.technician?.id);
          }).map((pos) => {
            const isUnavailable = unavailableTechs?.some(u => u.id === pos.technician?.id);
            return (
              pos && pos.latitude && pos.longitude && pos.technician ? (
                <MapMarker key={pos.id}
                  icon="truck"
                  lat={pos.latitude}
                  lng={pos.longitude}
                  technician={pos.technician}
                  unavailable={isUnavailable}
                  onClick={() => pos.technician && onTechClick(pos.technician)} />
              ) : null
            );
          })}
        </GoogleMapReact>
      </div>
    </div>
  );
}
/***/
